<template>
    <div class="app">
        <header>
            <i class="el-icon-arrow-left"  @click="$router.go(-1)"></i>
            <span class="pageTitle">头像</span>
            <span class="save" @click="save">保存</span>
        </header>
        <div class="content">
            <div class="blank"></div>
            <div>
                <div class="imgBox">
                    <div class="icon">
                        <croppa v-model="croppa"
                                disable-click-to-choose
                                placeholder="暂无图片"
                                :placeholder-font-size="14"
                                :width="photoW"
                                :height="photoH"
                                :initial-image="camPicImg"
                        >
                        </croppa>
                    </div>
                </div>
                <div class="button">
                    <button @click="fromPhoto">从相册选一张</button>
                    <button @click="fromCam">拍一张照片</button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { Navbar, TabItem,Switch,Actionsheet } from 'mint-ui';  
import { uploadImg } from '@/assets/js/axios'
import { getPicture } from '@/assets/js/nativeServices'

export default {
  data() {
      return {
        croppa: {},
        camPicImg: ''
      }
  },
  props: {

      photoW: {
        type: Number,
        default: 231
      },

      photoH: {
        type: Number,
        default: 210
      },

      action: {
        type: String,
        default: 'userapp_personal'
      }

    },
  computed: {},
  components: {},
  methods: {
      close () {
        this.$emit('uploadIsClose')
      },

      fromPhoto () {
        getPicture(false, imageData => {
          this.camPicImg = imageData
          this.croppa.refresh()
        }, err => {
          alert('Failed because: ' + err)
        })
      },

      fromCam () {
        getPicture(true, imageData => {
          this.camPicImg = imageData
          this.croppa.refresh()
        }, err => {
          alert('Failed because: ' + err)
        })
      },

      save() {
        if (!this.croppa.hasImage()) {
          alert('你还没上传图片')
          return
        }

        this.croppa.generateBlob((blob) => {
          var fd = new FormData()
          fd.append('file', blob, 'filename.jpg')
          fd.append('other', 'blahblahblah')
          console.log(blob)
          uploadImg(fd, this.action)
            .then(res => {
              console.log(this.croppa)
              this.$emit('uploadOk', res)
            })
            .catch(e => {
              console.log(e)
            })
        })

      }
  },           
};
</script>

<style scoped>
.app {
  width: 100%;
  height: 100%;
  display: flex;
  display: -webkit-flex;
  flex-direction: column;
}
header {
  height: 1.5rem;
  width: 100%;
  background-image: linear-gradient(-134deg, #299EAD 0%, #299EAD 100%);
  position: fixed;
  z-index: 1;
}
.blank {
  height: 1.5rem;
  width: 100%;
}
.pageTitle {
  font-size: 0.5rem;
  text-align: center;
  color: white;
  position: absolute;
  top: 50%;
  left: 45%;
  transform: translateY(-50%);
}
.save {
  font-size: 0.42rem;
  text-align: center;
  color: white;
  position: absolute;
  top: 50%;
  left: 88%;
  transform: translateY(-50%);
}
.el-icon-arrow-left {
  font-size: 0.7rem;
  color: white;
  position: absolute;
  top: 50%;
  transform: translate(50%, -50%);
}
.content {
  position: absolute;
  flex: 1;
  background-color: rgba(241, 241, 241, 1);
  height: 100%;
  width: 100%;
  overflow-x: hidden;
}
.imgBox{
    width: 100%;
    height: 9.87rem;
    background-color: rgba(229,229,229,1);
    position: relative;
}
.icon{
    width: 8.71rem;
    height: 8.95rem;
    border: 0.03rem solid rgba(245, 245, 245, 1);
    text-align: center;
    border-radius: 0.13rem;
    line-height: 0.53rem;
    position: absolute;
    top: 0.39rem;
    left: 0.58rem;
}
.icon img{
    width: 8.71rem;
    height: 8.95rem;
}
.button{
    height: 5.97rem;
    width: 100%;
    text-align: center;
}
.button button{
    width: 6.58rem;
    height: 1.18rem;
    margin-top: 0.68rem;
    border-radius: 0.16rem;
    background-color: rgba(41, 158, 173, 1);
    text-align: center;
    font-size: 0.42rem;
    color: #fff;
}
</style>




// WEBPACK FOOTER //
// src/components/mine/touxiang.vue